/*
 * 模块名称: 结算查询页面
 * 创建人: DrugsZ
 * 创建时间: 2018-01-05 10:46:13
 * 修改人:DrugsZ
 * 最后修改时间: 2018-01-05 10:46:13
 */
<template>
  <div v-loading="loadingstatus" element-loading-text="加载中">
      <div class="form-horizontal">
              <div class="form-group">
                  <div class="col-sm-3" v-if="levv!=3">
                    <label for="" class="col-sm-4 control-label">救援公司</label>
                    <div class="col-sm-8">
                            <select class="form-control" v-model="queryParam.customerIds">
                                <option v-for="(item, index) in groupList" :value="item.id" v-bind:key="'group' + index">{{item.groupName}}</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-sm-3" v-else>
                    <label for="" class="col-sm-4 control-label">费用类型</label>
                    <div class="col-sm-8">
                        <select class="form-control" v-model="queryParam.priceType">
                                <option v-for="(item, index) in groupList" :value="item.udccode" :key="'groupList' + index">{{item.udcname}}</option>
                            </select>
                    </div>
                  </div>
                  <label class="col-sm-1 control-label">清账时间范围(起)</label>
                  <div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
                      <datepicker class="form-control"  v-model="queryParam.closeoutStartTime"></datepicker>
                      <p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
                  </div><label class="col-sm-1 control-label">清账时间范围(止)</label>
                  <div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
                      <datepicker class="form-control"  v-model="queryParam.closeoutEndTime"></datepicker>
                      <p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
                  </div>
              </div>
              <div class="form-group">
                  <div class="col-sm-12 t_right">
                      <button class="btn btn-primary" @click="toSearch">查询</button>
                      <button class="btn btn-primary" @click="reset">重置</button>
                    </div>
              </div>
              <div class="hr-line-dashed"></div>
                <div class="form-group t_right">
                    <button class="btn btn-primary" @click="exportData" v-if="levv!=1">报表导出</button>
                    <button class="btn btn-primary" @click="exportDataForDidi" v-else>报表及凭证导出</button>
                </div>
          </div>
          <!-- 表格开始 -->
          <div class="table-responsive">
				<div style="overflow: auto;">
					<table class="table mb0px table-striped table-bordered table-hover" style="min-width:1600px;">
						<thead>
			    				<tr role="row">
								<th v-if="levv!=3">救援公司</th>
								<th>结算时间范围</th>
								<th v-if="levv==1">平台费用(¥)</th>
								<th>清账时间</th>
								<th>经办人姓名</th>
								<th v-if="levv!=1">联系方式</th>
								<th v-if="levv!=2">结算说明</th>
								<th v-if="levv==1"></th>
							</tr>
						</thead>
						<transition-group name="list-complete" tag="tbody">
							<tr v-for="(fileInfo,index) in fileInfoList" v-bind:key="index + 'fileInfolist'" class="list-complete-item">
								<td v-if="levv!=3">{{fileInfo.customerName}}</td>
								<td>{{getTimeStr(fileInfo)}}</td>
								<td v-if="levv==1">{{fileInfo.totalPriceStr}}</td>
								<td>{{fileInfo.closeoutTimeStr}}</td>
								<td>{{fileInfo.name}}</td>
                                <td v-if="levv!=1">{{fileInfo.mobile}}</td>
                                <td v-if="levv!=2">{{fileInfo.memo}}</td>
								<td v-if="levv==1" class="t_center">
									<a @click="getMaxPic(fileInfo.certificatePhoto)">详情</a>
								</td>
							</tr>
						</transition-group>
					</table>
				</div>
		  </div>
          <pagination v-if="fileInfoList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
  </div>
</template>
<script>
    import Datepicker from 'components/common/datepicker/Datepicker'
    import Pagination from 'components/common/Pagination'
    import { OPERATE_EXCEPTION} from 'static/message'
    import toastr from 'assets/plugins/toastr/toastr.min.js'
    import {ShowMorePic} from 'util/rescueUtil.js'
    export default{
      name: 'AccountList',
      components: {
        Pagination,
        Datepicker
      },
      data () {
        return {
          fileInfoList: [],
          queryParam: {
            customerIds: '',
            closeoutEndTime: '',
            priceType: 1,
            closeoutStartTime: ''
          },
          groupList: [],
          loadingstatus: false,
          pageInfo: {},
          picUrl: process.env.PIC_PATH,
          maxPic: null
        }
      },
      beforeMount () {
        if (this.levv != 3) {
          this.getCoustomer()
        } else {
          this.getUdc()
        }
        this.loadData()
      },
      computed: {
        levv () {
          return this.$store.state.user.levv
        },
        validDates: function () {
          if (this.queryParam.startTime && this.queryParam.endTime && this.queryParam.startTime > this.queryParam.endTime) {
            return false
          } else {
            return true
          }
        }
      },
      methods: {
        getCoustomer () {
          this.loadingstatus = true
          this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/account/customer/fleet')
                .then(res => {
                  if (res.body.success) {
                    this.groupList = res.body.data
                    if (this.levv != 3) {
                      let obj = {
                        groupName: '全部',
                        id: ''
                      }
                      this.groupList.unshift(obj)
                    }
                  } else {
                    this.$emit('onerror', res.body.message)
                  }
                  this.loadingstatus = false
                }, res => {
                  this.$emit('onerror', res.body.message)
                  this.loadingstatus = false
                }).catch(res => {
                  this.$emit('onerror', '请求出错啦')
                  this.loadingstatus = false
                })
        },
        getUdc () {
          this.loadingstatus = true
          this.$http.get(process.env.API_ROOT + '/system/udcs/license/2', { params: { udcTypes: 'PRICE_TYPE' } })
                .then(res => {
                  this.loadingstatus = false
                  if (res.body.success) {
                    this.groupList = res.data.data['PRICE_TYPE']
                  } else {
                    this.$emit('onerror', res.body.message)
                  }
                }, res => {
                  this.loadingstatus = false
                  this.$emit('onerror', res.body.messgae)
                }).catch(res => {
                  this.loadingstatus = false
                  this.$emit('onerror', OPERATE_EXCEPTION)
                })
        },
        getTimeStr (item) {
          if (item.closingStartTimeStr && item.closingEndTimeStr) {
            return item.closingStartTimeStr + '至' + item.closingEndTimeStr
          } else {
            return ''
          }
        },
        reset () {
          this.queryParam.customerIds = ''
          this.queryParam.closeoutEndTime = ''
          this.queryParam.priceType = 1
          this.queryParam.closeoutStartTime = ''
          this.queryParam.page_index = 1
        },
        toSearch () {
          this.queryParam.page_index = 1
          this.loadData()
        },
        getPageNo (num) {
          this.queryParam.page_index = num
          this.loadData()
        },
        loadData () {
                // let type ;
                // if(this.levv == 1){
                //     type = 1
                // }else if(this.levv == 3){
                //     type =2
                // }
                // this.queryParam.priceType = type
          this.loadingstatus = true
          this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/cost/list/closing/cost', {params: this.queryParam})
                .then(res => {
                  if (res.body.success) {
                    const {pageNum, pages, total, isFirstPage, isLastPage} = res.body.data
                    this.fileInfoList = res.body.data.list
                    this.pageInfo = {
                      pageNum: pageNum,
                      pages: pages,
                      total: total,
                      isFirstPage: isFirstPage,
                      isLastPage: isLastPage
                    }
                  } else {
                    this.$emit('onerror', res.body.message)
                  }
                  this.loadingstatus = false
                }, res => {
                  this.loadingstatus = false
                  this.$emit('onerror', res.body.message)
                }).catch(res => {
                  this.loadingstatus = false
                  this.$emit('onerror', res.body.message)
                })
        },
        exportData () {
          let url
          url = '/rescue-api/cost/closing/cost/export'
          this.loadingstatus = true
          this.$http.get(process.env.API_INSURANCE_ROOT + url, {params: this.queryParam})
                .then((res) => {
                  if (res.body.success) {
                    let str = res.body.data
					//   var path = "http://192.168.1.53:8888/api";
                    var path = process.env.EXPORT_PATH
					    var api = process.env.API_ROOT
                    var fileName = path + api + '/noauth/export?url=' + str + '&path=' + this.$store.state.user.userId
		    			var elemIF = document.createElement('iframe')
				      	elemIF.src = fileName
				        elemIF.style.display = 'none'
				        document.body.appendChild(elemIF)
                  } else {
                    this.$emit('onerror', res.body.message)
                  }
                  this.loadingstatus = false
                }, res => {
                  this.loadingstatus = false
                  this.$emit('onerror', res.body.message)
                }).catch(res => {
                  this.loadingstatus = false
                  this.$emit('onerror', '请求异常')
                })
        },
        exportDataForDidi () {
          let str = process.env.API_INSURANCE_ROOT + '/rescue-api/cost/closing/cost/with/images/onceExport'
          let token = this.$store.state.user.accesstoken
          str += '?token='
          str += token
          var elemIF = document.createElement('iframe')
          elemIF.src = str
          elemIF.style.display = 'none'
          document.body.appendChild(elemIF)
        },
        getMaxPic (url) {
          let data = url.split(',')
          this.maxPic = this.maxPic == null ? new ShowMorePic('#ac-to-didi') : this.maxPic
          this.maxPic.showMaxPic(data)
        }
      }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AccountList.vue?ac29620e